import Axios from "axios";
import {
  SET_MASTER_SALES_CONTACT_LIST,
  UNSET_MASTER_SALES_CONTACT_LIST,
} from "@/store/mutation-types";

import { masterSalesContactResource } from "@/store/api";

const state = {
  getMasterSalesContactList: [],
};

const getters = {
  getMasterSalesContactList(state) {
    return state.getMasterSalesContactList;
  },
};

const mutations = {
  [SET_MASTER_SALES_CONTACT_LIST](state, data) {
    state.getMasterSalesContactList = data;
  },
  [UNSET_MASTER_SALES_CONTACT_LIST](state) {
    state.getMasterSalesContactList = [];
  },
};

const actions = {
  getMasterSalesContactList({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      Axios.get(masterSalesContactResource, { params })
        .then((response) => {
          commit(SET_MASTER_SALES_CONTACT_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_MASTER_SALES_CONTACT_LIST);
          reject(error);
        });
    });
  },

  saveMasterSalesContact({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.post(masterSalesContactResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  updateMasterSalesContact({ commit }, { id, data }) {
    commit("SET_LOADING", { color: "primary" });

    const url = `${masterSalesContactResource}/${id}`;

    return new Promise((resolve, reject) => {
      Axios.put(url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getMasterSalesContact({ commit }, id) {
    commit("SET_LOADING", { color: "primary" });

    const url = `${masterSalesContactResource}/${id}`;

    return new Promise((resolve, reject) => {
      Axios.get(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

